module.exports = __webpack_public_path__ + "static/img/联系我们.9653635.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/about_article/联系我们.png
// module id = 649
// module chunks = 1